var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSize12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE0E5",
    d: "M.545.176h97.862v82.245H.545z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.284 35.573h59.342v12.493H19.284z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECF0",
    d: "M21.366 38.697h38.52v6.246h-38.52z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#223143",
    d: "M63.009 38.697h13.534v6.246H63.009z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize12);
export default __webpack_public_path__ + "static/media/size-12.78f65570438e41534fc16fcd2c3b8383.svg";
export { ForwardRef as ReactComponent };